import React, { createContext, useContext, useEffect, useMemo, useState } from 'react'
import { auth } from '../services/auth'

const LandlordContext = createContext(null)

const initialState = {
  me: null,
  email: '',
  isLandlord: false,
  loading: true,
  error: '',
}

export function LandlordProvider({ children }) {
  const [state, setState] = useState(initialState)

  useEffect(() => {
    let alive = true

    async function load() {
      if (!auth.isAuthenticated()) {
        if (alive) setState({ ...initialState, loading: false })
        return
      }
      try {
        const me = await auth.me()
        if (!alive) return
        setState({
          me,
          email: me?.email || '',
          isLandlord: !!me?.is_landlord,
          loading: false,
          error: '',
        })
      } catch (error) {
        if (!alive) return
        setState({
          ...initialState,
          loading: false,
          error: error.message || 'Unable to load landlord account.',
        })
      }
    }

    load()
    return () => {
      alive = false
    }
  }, [])

  const value = useMemo(() => state, [state])

  return (
    <LandlordContext.Provider value={value}>
      {state.loading ? (
        <div>Loading…</div>
      ) : state.me && !state.isLandlord ? (
        <div className="border-b border-red-200 bg-red-50 px-4 py-3 text-sm font-medium text-red-800">
          This is a landlord account area.
        </div>
      ) : (
        children
      )}
    </LandlordContext.Provider>
  )
}

export function useMe() {
  const context = useContext(LandlordContext)
  if (!context) throw new Error('useMe must be used inside LandlordProvider')
  return context
}

export function useLandlord() {
  return useMe()
}
